<template>
  <div class="app-container">
    <div class="head-container">
      <div class="filter-container">
        <el-input
          v-model="query.keyword"
          clearable
          size="small"
          placeholder="活动名称/编码"
          class="filter-item"
          style="width: 200px; margin-right: 10px;"
          @keyup.enter.native="loadList"
        />
        <el-select
          v-model="query.storeCode"
          clearable
          filterable
          size="small"
          placeholder="门店编码"
          class="filter-item"
          style="width: 220px; margin-right: 10px;"
        >
          <el-option
            v-for="item in storeOptions"
            :key="item.storeCode"
            :label="(item.storeName || '') + ' [' + (item.storeCode || '') + ']'"
            :value="item.storeCode"
          />
        </el-select>
        <el-select
          v-model="query.status"
          clearable
          size="small"
          placeholder="状态"
          class="filter-item"
          style="width: 130px; margin-right: 10px;"
        >
          <el-option label="启用" :value="1" />
          <el-option label="停用" :value="0" />
          <el-option label="已结束" :value="2" />
        </el-select>
        <el-button class="filter-item" size="mini" type="primary" icon="el-icon-search" @click="loadList">
          查询
        </el-button>
        <el-button class="filter-item" size="mini" icon="el-icon-refresh-left" @click="resetQuery">
          重置
        </el-button>
      </div>
    </div>

    <el-table v-loading="loading" :data="list" size="small" style="width: 100%;">
      <el-table-column prop="activityName" label="活动名称" min-width="160" show-overflow-tooltip />
      <el-table-column prop="activityCode" label="活动编码" min-width="160" show-overflow-tooltip />
      <el-table-column prop="storeName" label="门店" min-width="120" show-overflow-tooltip />
      <el-table-column prop="storeCode" label="门店编码" min-width="120" show-overflow-tooltip />
      <el-table-column prop="status" label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 1" size="mini" type="success">启用</el-tag>
          <el-tag v-else-if="scope.row.status === 0" size="mini" type="info">停用</el-tag>
          <el-tag v-else-if="scope.row.status === 2" size="mini" type="warning">已结束</el-tag>
          <span v-else>{{ scope.row.status }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="startTime" label="开始时间" width="170">
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.startTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="endTime" label="结束时间" width="170">
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.endTime) }}
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin-top: 16px; text-align: right;"
      background
      layout="total, prev, pager, next, sizes"
      :current-page="query.page + 1"
      :page-size="query.size"
      :page-sizes="[10, 20, 50]"
      :total="total"
      @current-change="handlePageChange"
      @size-change="handleSizeChange"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { fetchSignsActivities, fetchSignsStores } from '@/api/h5-admin-signs'

export default {
  name: 'H5AdminSignsActivities',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      storeOptions: [],
      query: {
        page: 0,
        size: 20,
        keyword: '',
        storeCode: null,
        status: null
      }
    }
  },
  created() {
    this.loadStores()
    this.loadList()
  },
  methods: {
    formatDateTime(value) {
      if (value == null || value === '') return '-'
      const d = dayjs(value)
      return d.isValid() ? d.format('YYYY-MM-DD HH:mm:ss') : String(value)
    },
    loadStores() {
      fetchSignsStores()
        .then(res => {
          this.storeOptions = res.data || []
        })
        .catch(() => {
          this.storeOptions = []
        })
    },
    loadList() {
      this.loading = true
      const params = {
        page: this.query.page,
        size: this.query.size,
        keyword: this.query.keyword || undefined,
        storeCode: this.query.storeCode || undefined,
        status: this.query.status === null || this.query.status === '' ? undefined : this.query.status
      }
      fetchSignsActivities(params)
        .then(res => {
          const data = res.data || {}
          this.list = data.content || []
          this.total = data.totalElements || 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetQuery() {
      this.query.keyword = ''
      this.query.storeCode = null
      this.query.status = null
      this.query.page = 0
      this.loadList()
    },
    handlePageChange(page) {
      this.query.page = Math.max(page - 1, 0)
      this.loadList()
    },
    handleSizeChange(size) {
      this.query.size = size
      this.query.page = 0
      this.loadList()
    }
  }
}
</script>
